export default __webpack_public_path__ + "static/media/howto-img-03@small.62f1866a.jpg";